module.exports = __webpack_public_path__ + "media/images/frontend/logo-decreto-796ba3da2a4065a01706b1ff3a1424e4.png";